import { grnActionTypes } from '../actions/grnActions';

const GRNReducers = (state = {}, action) => {
  switch (action.type) {
    case grnActionTypes.GET_DOWNLOAD_GRN_DATA.LOADING: {
      const { getDownloadGRNLoading } = action;
      return {
        ...state,
        getDownloadGRNLoading,
      };
    }
    case grnActionTypes.UPDATE_GRN_STATUS.LOADING: {
      const { updateGRNStatusLoading } = action;
      return {
        ...state,
        updateGRNStatusLoading,
      };
    }
    case grnActionTypes.GET_GRN.LOADING: {
      const { getGRNLoading } = action;
      return {
        ...state,
        getGRNLoading,
      };
    }
    case grnActionTypes.GET_GRN.SUCCESS: {
      const { grnData } = action;
      return {
        ...state,
        grnData,
      };
    }
    case grnActionTypes.GET_GRN_BY_ID.LOADING: {
      const { getGRNByIdLoading } = action;
      return {
        ...state,
        getGRNByIdLoading,
      };
    }
    case grnActionTypes.GET_GRN_BY_ID.SUCCESS: {
      const { selectedGRN } = action;
      return {
        ...state,
        selectedGRN,
      };
    }
    case grnActionTypes.CREATE_GRN.LOADING: {
      const { createGRNLoading } = action;
      return {
        ...state,
        createGRNLoading,
      };
    }
    case grnActionTypes.UPDATE_GRN.LOADING: {
      const { updateGRNLoading } = action;
      return {
        ...state,
        updateGRNLoading,
      };
    }
    case grnActionTypes.DELETE_GRN.LOADING: {
      const { deleteGrnLoading } = action;
      return {
        ...state,
        deleteGrnLoading,
      };
    }
    case grnActionTypes.UPDATE_GRN_WORKFLOW_STEP.LOADING: {
      const { updateGRNWorkflowStepLoading } = action;
      return {
        ...state,
        updateGRNWorkflowStepLoading,
      };
    }
    case grnActionTypes.QUICK_UPDATE_GRN.LOADING: {
      const { quickUpdateGRNLoading } = action;
      return {
        ...state,
        quickUpdateGRNLoading,
      };
    }
    case grnActionTypes.SEND_GRN_EMAIL_TO_VENDOR.LOADING: {
      const { sendGRNMailToVendorLoading } = action;
      return {
        ...state,
        sendGRNMailToVendorLoading,
      };
    }
    default: {
      return state;
    }
  }
};

export default GRNReducers;
